module.exports = __webpack_public_path__ + "files/689c2e7c8cb27a173dd72f94b1676ec0.png";